import { push } from "connected-react-router";
import { App, useGetAppListItemQuery, useGetAppsForOrgQuery, useGetTotalAppsForOrgQuery } from "generated/graphql";
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { isNotNullOrUndefined } from "utils/isNotNullOrUndefined";
import { AppSwitcher } from "./AppSwitcher";

export interface AppSwitcherContainerProps { }

/**
 * Container for the app switcher component in the site header
 */
export const AppSwitcherContainer: FC<AppSwitcherContainerProps> = (props) => {

    const match = useRouteMatch<{ appId?: string, organizationId?: string }>("/:organizationId/:appId");

    let organizationId: string;
    let appId: string;

    if (match) {
        organizationId = match.params.organizationId;
        // TODO: We need a better way to keep these in sync with those defined
        // on the org route.
        const orgRoutes = ["apps", "settings", "members", "analytics"];
        appId = orgRoutes.includes(match.params.appId) ? undefined : match.params.appId;
    }

    const [showItems, setShowItems] = useState<boolean>(false);
    const [search, setSearch] = useState<string>("");

    let name: string;

    if (search) {
        name = search.trim().toLowerCase();
    }

    const [getApps] = useGetAppsForOrgQuery({
        pause: !showItems,
        requestPolicy: "cache-and-network",
        variables: {
            organizationId,
            from: 0,
            size: 8,
            name,
        },
    });

    const [getApp] = useGetAppListItemQuery({
        pause: !appId,
        requestPolicy: "cache-and-network",
        variables: {
            appId,
        },
    });

    const [getTotalApps] = useGetTotalAppsForOrgQuery({
        requestPolicy: "cache-and-network",
        pause: !organizationId || organizationId === "admin",
        variables: {
            organizationId
        }
    });

    const finished = !getApps.stale && getApps?.data?.org?.apps?.total

    const apps = getApps.data?.org?.apps?.apps.filter(isNotNullOrUndefined) || [];

    // get selected app from the state
    const app = getApp.data?.app;

    // this is used to know if we need to display the drop down button or not
    // if they only have one then they can't change apps!
    const totalApps = getTotalApps.data?.org?.apps?.total;

    const fetching = getApp.fetching;
    const fetchingApps = getApps.fetching;

    const dispatch = useDispatch();

    function onSelectApplication(app: App) {
        dispatch(push(`/${organizationId}/${app.appId}`));
    }

    return organizationId ? (
        <AppSwitcher
            app={app}
            apps={apps}
            totalApps={totalApps}
            search={search}
            isLoading={fetching}
            isLoadingItems={fetchingApps}
            onSelectApplication={onSelectApplication}
            onSearchChange={setSearch}
            showItems={showItems}
            onShowItemsChange={setShowItems}
            finished={finished}
        />
    ) : (
        <></>
    );
};
